import React, { useState, useEffect, useCallback } from "react";
import { db } from "../config/firestore";
import { doc, getDoc } from "firebase/firestore";
import WordleGame from "./WordleGame";

const STORAGE_KEY = "easterEggWordle";

function loadSavedGame() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (raw) return JSON.parse(raw);
  } catch {}
  return null;
}

function saveGame(state) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
  } catch {}
}

const EasterEgg = () => {
  const [showModal, setShowModal] = useState(false);
  const [solution, setSolution] = useState(null);
  const [loading, setLoading] = useState(false);

  // Restore game state from localStorage (or start fresh)
  const saved = loadSavedGame();
  const [guesses, setGuesses] = useState(saved?.guesses ?? []);
  const [currentGuess, setCurrentGuess] = useState(saved?.currentGuess ?? "");
  const [gameOver, setGameOver] = useState(saved?.gameOver ?? false);
  const [won, setWon] = useState(saved?.won ?? false);

  // Persist game state on every change
  const persistGame = useCallback(() => {
    saveGame({ guesses, currentGuess, gameOver, won });
  }, [guesses, currentGuess, gameOver, won]);

  useEffect(() => {
    persistGame();
  }, [persistGame]);

  const fetchSolution = async () => {
    if (solution) return;
    setLoading(true);
    try {
      const docRef = doc(db, "easterEgg", "ke9HxMje48xd7wk4oYT3");
      const docSnap = await getDoc(docRef);
      if (docSnap.exists()) {
        setSolution(docSnap.data().solution);
      }
    } catch (error) {
      console.error("Error fetching easter egg:", error);
    }
    setLoading(false);
  };

  const handleOpen = () => {
    setShowModal(true);
    fetchSolution();
  };

  const handleClose = () => {
    setShowModal(false);
  };

  return (
    <>
      <div className="flex justify-center my-6">
        <button
          onClick={handleOpen}
          className="egg-wobble text-4xl opacity-60 hover:opacity-100 transition-opacity duration-300 focus:outline-none cursor-pointer"
          title="?"
          aria-label="Easter egg"
        >
          🥚
        </button>
      </div>

      {showModal && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50"
          onClick={(e) => {
            if (e.target === e.currentTarget) handleClose();
          }}
        >
          <div
            className="bg-white rounded-xl shadow-2xl max-w-2xl w-full mx-4 max-h-[90vh] overflow-y-auto"
            onClick={(e) => e.stopPropagation()}
          >
            {loading ? (
              <div className="flex flex-col items-center justify-center py-16">
                <div className="animate-spin rounded-full h-10 w-10 border-t-4 border-b-4 border-advent-primary mb-3"></div>
                <p className="text-gray-500">Laster...</p>
              </div>
            ) : solution ? (
              <WordleGame
                solution={solution}
                onClose={handleClose}
                guesses={guesses}
                setGuesses={setGuesses}
                currentGuess={currentGuess}
                setCurrentGuess={setCurrentGuess}
                gameOver={gameOver}
                setGameOver={setGameOver}
                won={won}
                setWon={setWon}
              />
            ) : (
              <div className="text-center py-16 px-4">
                <p className="text-gray-500">Kunne ikke laste spillet.</p>
                <button
                  onClick={handleClose}
                  className="mt-4 px-6 py-2 bg-advent-primary hover:bg-advent-primary-dark text-white rounded-lg font-semibold transition-all"
                >
                  Lukk
                </button>
              </div>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default EasterEgg;
